import React, { useState } from 'react';

import { FilterState, NestedItem } from '@/components/FilterManager/types';

import BaseNestedFilter from './BaseNestedFilter';

export const NestedFilter = ({
  filter,
  setFilter,
  item,
}: {
  filter: FilterState;
  setFilter: (filter: any) => void;
  item: NestedItem;
}) => {
  const [filterIdToOpen, setFilterIdToOpen] = useState<string>('');
  const pillsConfig = item.pillsConfig || [];

  return (
    <>
      {Object.keys(filter).map((key) => {
        const pillConfig = pillsConfig.find((pillConfig) => pillConfig.id === key);
        if (pillConfig) {
          return (
            <pillConfig.Component
              key={key}
              filter={filter}
              filterIdToOpen={filterIdToOpen}
              setFilter={setFilter}
              setFilterIdToOpen={setFilterIdToOpen}
            />
          );
        }
        return null;
      })}
      <BaseNestedFilter
        CustomRenderer={item.CustomRenderer}
        filter={filter}
        headerProps={item.headerProps}
        id={item.id}
        listConfig={item.listConfig}
        pillsConfig={pillsConfig}
        queryParams={item.queryParams}
        setFilter={setFilter}
        setFilterIdToOpen={setFilterIdToOpen}
        uiConfig={item.uiConfig}
      />
    </>
  );
};

export default NestedFilter;
